import React from 'react';
import { useTranslation } from 'react-i18next';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const ContractSettings: React.FC = () => {
    const { t } = useTranslation();

    const settings: SettingsSettingType[] = [
        {
            title: 'contract.settings.numbering_scheme_title',
            explanationText: 'contract.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'contract_numbering_scheme',
                    placeholder: '',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false,
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'contract_current_number',
                    group: 'field-row',
                    width: '30%',
                }
            ]
        },
        {
            title: 'contract.settings.job_reference_title',
            explanationText: 'contract.settings.job_reference_explanation',
            fields: [
                {
                    type: 'render',
                    render: () => (
                        <div className='settings-tag-grid'>
                            <span className='tag-label'>{'{contract_number}'}</span>
                            <span className='tag-value'>{t('contract.settings.contract_number_tag_description')}</span>
                            <span className='tag-label'>{'{number:02d}'}</span>
                            <span className='tag-value'>{t('contract.settings.sequence_number_tag_description')}</span>
                            <span className='tag-label'>{'{year}'}</span>
                            <span className='tag-value'>{t('contract.settings.creation_year_tag_description')}</span>
                            <span className='tag-label'>{'{number_per_year:02d}'}</span>
                            <span className='tag-value'>{t('contract.settings.yearly_sequence_number_tag_description')}</span>
                        </div>
                    ),
                },
                {
                    type: 'text',
                    label: 'contract.settings.reference_scheme_label',
                    name: 'contract_job_reference_scheme',
                    placeholder: '',
                    group: 'field-row',
                    width: '40%',
                    shouldAutoFocus: false,
                }
            ]
        },
    ];

    return (
        <SettingsContainer settings={settings} environmentScope={true} />
    );
};

export default ContractSettings;
